export default __webpack_public_path__ + "static/media/rock.7e544c1f.png";